import React from "react";
import RevenueGraph from "./RevenueGraph";
import "./revenue-hero.css";

const RevenueHero = () => {
  return (
    <section className="revenue-hero">
      <div className="revenue-card">

        {/* GRAPH AREA = POSITIONING CONTEXT */}
        <div className="graph-wrapper">

          {/* TEXT OVERLAY (TOP-LEFT OF GRAPH) */}
          <div className="graph-overlay-text">
            <span className="badge-pill wow">OUR METHOD</span>

            <h1 className="hero-title">
              Revenue in Weeks <br />
              <span className="animate-charcter">— Not Months</span>
            </h1>

            <p className="hero-text">
              Most startups fail because they waste months (and cash) building
              products nobody asked for. We reverse that risk-first mindset
              with a validation-driven, speed-focused launch model.
            </p>

            <div className="launch-timeline">
              <p className="timeline-intro">Our proven launch timeline:</p>

              <p className="launch-step">
                <strong>Week 2 — Validation Complete</strong>
                Test the idea with real users and real feedback.
              </p>

              <p className="launch-step">
                <strong>Week 8 — MVP Live</strong>
                Launch a working, scalable product.
              </p>

              <p className="launch-step">
                <strong>Week 10 — Rapid Iteration</strong>
                Improve based on usage and insights.
              </p>

              <p className="launch-step">
                <strong>Week 12 — First Paying Users</strong>
                Start generating real revenue.
              </p>
            </div>

            <div className="cta-sec">
              <a href="/contact" className="primary-btn">
                Let’s talk →
              </a>
              <a
                href="/no-code-app-budget-calculator"
                className="budget-calc-link"
              >
                Calculate Your App Budget
              </a>
            </div>
          </div>

          {/* ACTUAL GRAPH */}
          <RevenueGraph />

        </div>

      </div>
    </section>
  );
};

export default RevenueHero;
